const SidebarLanguageSwitch = ({ value, onChange, className = "" }) => {
    return (
        <div className={`flex items-center gap-4 text-xs text-slate-500 px-4 ${className}`}>
            <button
                type="button"
                onClick={() => onChange("GR")}
                className={value === "GR" ? "font-semibold text-slate-900 underline focus:outline-none" : "focus:outline-none"}
            >
                GR
            </button>
            <button
                type="button"
                onClick={() => onChange("EN")}
                className={value === "EN" ? "font-semibold text-slate-900 underline focus:outline-none" : "focus:outline-none"}
            >
                EN
            </button>
        </div>
    );
};

export default SidebarLanguageSwitch;
